export enum sortByDa {
    AA_FIRST = 1, // aa is sorted to the beginning of the array, before a
    AA_LAST = 2, // the default - aa is sorted to the end of the array, after å
    AA_ARING = 3, // aa is considered equal with å
}
